// **********************************************************
// Latest News
// **********************************************************

const latestNewsSlider = document.querySelectorAll('[data-slider="latest-news-slider"]');

const latestNewsSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 8,
  speed: 400,
  mousewheel: {
    forceToAxis: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
};

latestNewsSlider.forEach((el) => new Swiper(el, latestNewsSliderOptions));
